import React from "react";
import "./ProviderCard.css";
import '@fortawesome/fontawesome-free/css/all.css';

const ProviderCard = ({data}) => {
    return <>
        {
            data.name !== '' ?
                <div className="provider-card">
                    <div className="therapist-image">
                        <img src={data.image_url} />
                    </div>
                    <h3>{data.label}</h3>
                    <p className="therapist-skills">
                        {
                            data.specialties.slice(0, 2).map((item, i) => {
                                return item.text + ((data.specialties.slice(0, 2).length !== i + 1) ? ', ' : '');
                            })
                        }
                    </p>
                    <div className="phone-line">
                        <i className="fas fa-phone"></i>
                        <a href={"tel:" + data.phone_number} target={"_blank"}>{data.phone_number}</a>
                    </div>
                    <div className="address-line">
                        <i className="fas fa-map-marker-alt"></i>
                        <a target="_blank" href={"https://maps.google.com/?q=" + data.street_address + ", " + data.city + ", " + data.state}>{data.locale_name}</a>
                        <br/>
                        <a target="_blank" href={"https://maps.google.com/?q=" + data.street_address + ", " + data.city + ", " + data.state}>{data.street_address}, {data.city}, {data.state}</a>
                    </div>
                    <div className="appointment-block">
                        <a className="appointment-button"
                           target="_blank"
                           href={data.url}>Book Appointment</a>
                    </div>

                </div> : ''
        }

    </>;
};

export default ProviderCard;
